import OverlayRenderer from './overlay-renderer';
//LAZY import {fabric} from 'fabric';
import * as log from 'loglevel';
import RenderUtil from './render-util';
import Request from '../request';
import {ThemeConfig} from '../const';
import RendererRegistry from './renderer-registry';

class UploadRenderer extends OverlayRenderer {

    /*
    render(layer, context, canvas) {

        // INFO: to support unlimited interactive uploads per layer we would have to use a different logic here to add all current upload urls via a single layer
        if(layer.params.interactive && layer.params.multiple){

            CUSTOM logic to support 1:n  layer:uploads  ( could also be used for multiple text support )

        } else {
            return super.render(layer, context, canvas);
        }
    } */

    _getImage(layer, context, canvas, params = layer.params) {

        // upload reference from option
        if(params.option){
            let productOption = RenderUtil.getProductOption(params.option, context.options);

            if(productOption){
                // store layer reference ( could be used for single layer updates )
                productOption._layer = layer;

                if(productOption.value){

                    // NEW: use product image as upload source (useful if product image should be cropped)
                    if(productOption.value === '{product}'){
                        // use logic from product renderer (would support .variant / .imgPos setting)
                        let productUrl = RendererRegistry.renderers['product']._findProductUrl(layer, context);
                        if(productUrl){
                            productOption.value = productUrl;
                        }
                    }

                    let url = productOption.value;

                    // one based index of the rendered file ( the upload export of this file, product-preview.js withUploadExport )
                    layer._fileIndex = 1;

                    // multiple files selected -> select one  || NEW auto detect             || file index is defined force to use this specific index
                    if(productOption.params.multiple || url.indexOf(',') !== -1 || params.fileIndex){
                        let urls = url.split(',');

                        //  configured index || newest file
                        let index = params.fileIndex || urls.length;

                        // zero based but config 1 based
                        index-=1;

                        if(urls.length > index){
                            url = urls[index];
                            layer._fileIndex = index + 1;
                        } else {
                            // no upload found for this index
                            return Promise.resolve(null);
                        }
                    }

                    // NEW: layer editor actions

                    // flag to trigger options to render again (required to show/update the editor)
                    let renderOptions = false;

                    // flag to show editor below option
                    if(layer.params.layerEditor){

                        // INFO: we store the context info to use in LayerEditor
                        if(!layer._context){ // we use the context reference to check if already initialized
                            layer._context = context;
                            layer._canvas = canvas; // canvas reference (used to trigger updates on the right preview instance)
                            renderOptions = true;
                        }

                    } else if(layer._context){
                        // reset (editorMode only)
                        delete layer._context;
                        // trigger options to hide the editor
                        renderOptions = true;
                    }

                    // if liveCrop is active
                    if(params.crop) {

                        /* auto crop if visible changed (after already shown before - NOT used - better to auto crop once and then allow manual crop mode)
                        if(productOption.params.optionAutoCrop) {
                            INFO: requires code to be commented out in product-preview._renderLayer()
                            if(!context.cropMode && layer._object && layer._visibleChanged){
                                context.autoCrop = layer; // set this layer to be opened in crop mode
                            }
                        } */

                        //  upload button is linked to a dimension option & crop is enabled
                        if(productOption.params.optionDimension && productOption.params.dimensionCrop){

                            let productOptionCrop = RenderUtil.getProductOption(productOption.params.optionDimension, context.options);

                            // IMPORTANT: check if dimension option is visible (e.g format options + custom dimension - avoid updating wrong upload layer)
                            if (productOptionCrop && productOptionCrop.visible) {

                                // check if dimension controller has x/y set                                                           && no validation errors
                                if(productOptionCrop._controller && productOptionCrop._controller.x && productOptionCrop._controller.y && (!productOptionCrop.errors || productOptionCrop.errors.length === 0)){

                                    let dimensions = RenderUtil.getRefDimensions(layer, context);

                                    // compare ratio with two decimals
                                    let ratioLayer = Math.round((dimensions.width / dimensions.height) * 100) / 100;
                                    let ratioOption = Math.round((productOptionCrop._controller.x / productOptionCrop._controller.y) * 100) / 100;

                                    if(ratioLayer !== ratioOption){

                                        // check if Area=Box (refArea requires refRect: true and materializes the resolved area geometry into the ref* params)
                                        let hasBox = layer.params.refRect;

                                        // scale ratio based on full dimension max size
                                        if(layer._cropWidth === undefined || layer._cropHeight === undefined){
                                            layer._cropWidth = (hasBox && layer.params.refWidth) || context.config.width;
                                            layer._cropHeight = (hasBox && layer.params.refHeight) || context.config.height;
                                        }

                                        if(ratioOption > 1){
                                            layer.params.refWidth = layer._cropWidth;
                                            layer.params.refHeight = layer._cropWidth / ratioOption;
                                        } else {
                                            layer.params.refHeight = layer._cropHeight
                                            layer.params.refWidth = layer._cropHeight * ratioOption;
                                        }

                                        // save the initial X and Y positions  IMPORTANT: undefined check as X/Y could be 0 and it would be overwritten
                                        if(layer._cropX === undefined || layer._cropY === undefined){
                                            layer._cropX = (hasBox && layer.params.refX) || 0;
                                            layer._cropY = (hasBox && layer.params.refY) || 0;
                                        }

                                        // force to use of box dimensions (in case Full is selected - no-op for refArea consumers, refRect is required there)
                                        layer.params.refRect = true;

                                        // NEW: for refArea consumers the crop-derived geometry is a local override on the consumer
                                        // (the shared area layer is never mutated) marked via _cropRefArea - it only holds for the
                                        // area geometry it was derived from, _materializeArea drops it (and the _crop* caches)
                                        // when the resolved area changes (brand/variant switch)
                                        if(layer.params.refArea){
                                            layer._cropRefArea = layer._refAreaGeometry;
                                        }

                                        // NEW: central crop box relative to initial position
                                        layer.params.refX = layer._cropX + (layer._cropWidth / 2) - (layer.params.refWidth / 2);
                                        layer.params.refY = layer._cropY + (layer._cropHeight / 2) - (layer.params.refHeight / 2);

                                        /* DEPRECATED: center box on dimensions
                                        layer.params.refX = ( context.config.width / 2  ) - ( layer.params.refWidth / 2 );
                                        layer.params.refY = ( context.config.height / 2  ) - ( layer.params.refHeight / 2 );
                                        */

                                        //  auto crop new image NEW: dimension update - avoid first crop as dimension is set to match image
                                        if(layer._autoCrop !== false){
                                            context.autoCrop = layer; // set this layer to be opened in crop mode
                                        } else {
                                            // reset auto crop (only skip once)
                                            delete layer._autoCrop;
                                        }

                                        // NEW: flag to never auto open crop mode (root only - not in UI)
                                        if(layer.params.autoCrop === false){
                                            delete context.autoCrop;
                                        }

                                        ThemeConfig.productCropOverlay = false; // hacky way to avoid the crop overlay (required to allow changing dimensions while cropping)
                                    }
                                }
                            }
                        }

                    }

                    // trigger options to render the editor
                    if(renderOptions && context.productForm){
                        context.productForm.dispatchEvent(new CustomEvent('options:render', { detail: productOption, cancelable: true, bubbles: true }));
                    }

                    // only use cached if url has not changed AND rotate param not changed                                          AND image filters not changed (length check allows toggle of filter - currently not possible via UI)
                    if(layer._object && layer._url === url && (isNaN(layer.params.rotate) || layer._rotate === layer.params.rotate) && (!layer.params.filters || !layer._filters || layer._filters.length === layer.params.filters.length)){

                        // re-apply canvasRotate if layer was rotated
                        if(layer.params.autoRotate && layer._rotate !== 0) {
                            if (params.canvasRotate) {
                                context.canvasRotate = layer._rotate * (-1); // rotate full view in inverse to show from top to bottom
                            }
                        }

                        if (layer._restore) {
                            delete layer._restore;
                        }

                        return Promise.resolve(layer._object);
                    } else {
                        return new Promise((resolve, reject) => {

                            // apply auto scaling again for new upload
                            if(layer._interactive){
                                // NEW: exclude duplicated layers (from group editor) & restore from cart with coordinates
                                if (!layer._duplicate && !layer._restore) {
                                    delete layer._interactive;
                                    delete layer._interactiveScaled;
                                } else {
                                    delete layer._duplicate;
                                    delete layer._restore;
                                }
                            }

                            // crop enabled - auto crop new image
                            if(layer.params.crop){
                                context.autoCrop = layer; // set this layer to be opened in crop mode
                            }
                            // NEW: flag to never auto open crop mode (root only - not in UI)
                            if(layer.params.autoCrop === false){
                                delete context.autoCrop; // NEW: had to be added here as well as in productOptionCrop logic above
                            }

                            const prepareImage = (fabricImg) => {

                                if (fabricImg === undefined) {

                                    log.warn('upload url not found: ', url);

                                    // still resolve and not reject to continue rendering
                                    resolve(null);
                                }

                                // cache url
                                layer._url = url;

                                layer._rotate = 0;

                                // NEW: apply autoRotate when loading the image to avoid downstream complexity of rotated fabric objects (top/left is changed when rotating)
                                if(layer.params.autoRotate){

                                    let refDimensions = RenderUtil.getRefDimensions(layer, context);

                                    let object = fabricImg;

                                    if(object.width < object.height && refDimensions.width > refDimensions.height){
                                        layer._rotate = 90;
                                    } else if(object.width > object.height && refDimensions.width < refDimensions.height){
                                        layer._rotate = -90; // rotate backwards to avoid showing on it's head
                                    }
                                }

                                // NEW: params rotate (currently used in cropMode)
                                if(!isNaN(layer.params.rotate)){
                                    layer._rotate = layer.params.rotate;
                                }

                                if(layer._rotate !== 0){
                                    fabricImg.rotate(layer._rotate); // apply rotation

                                    layer.params.rotate = layer._rotate; // NEW: set rotation in params (required to avoid crop mode reset to set rotation back to 0 - which causes re-load of object)

                                    if(params.canvasRotate){
                                        context.canvasRotate = layer._rotate * (-1); // rotate full view in inverse to show from top to bottom
                                    }

                                    let options = {
                                        multiplier: 1, // exports the original dimensions
                                        format: layer._url.indexOf('.png') !== -1 ? 'png' : 'jpeg',
                                        quality: 1.0 // full quality for jpeg
                                    };

                                    // generate rotated image
                                    let dataURL = fabricImg.toDataURL(options);

                                    fabric.Image.fromURL(dataURL, (fabricRotatedImg) => {

                                        // image filters (includes resize filter if enabled)
                                        this._applyFilters(fabricRotatedImg, layer, context).then(() => {
                                            resolve(fabricRotatedImg);
                                        });

                                    });
                                } else {

                                    // image filters (includes resize filter if enabled)
                                    this._applyFilters(fabricImg, layer, context).then(() => {
                                        resolve(fabricImg);
                                    });
                                }

                            };

                            // NEW: custom SVG conversion to image (svg works with fabric.Image.fromURL but SVG without width/height attributes were not supported)
                            if(url.indexOf('.svg') !== -1){
                                fabric.loadSVGFromURL(url, (objects, options) => {

                                    if (objects === undefined) {

                                        log.warn('upload url not found: ', url);

                                        // still resolve and not reject to continue rendering
                                        resolve(null);
                                        return;
                                    }

                                    let fabricSvg = fabric.util.groupSVGElements(objects, options);

                                    // NEW: svg upload + colorize (only behind feature flag) > return grouped SVG to allow colorization (disables other filters and auto rotate)
                                    if(params.color || params.optionColor){ // connected to color but not yet selected
                                        layer._url = url; // IMPORTANT: cache url to avoid re-processing of SVG (also prevents interactive reset)
                                        resolve(fabricSvg);
                                        return;
                                    }

                                    // NEW: no crop & no filters - return SVG directly
                                    if(!params.crop && !params.filters){
                                        layer._url = url; // IMPORTANT: cache url to avoid re-processing of SVG (also prevents interactive reset)
                                        resolve(fabricSvg);
                                        return;
                                    }

                                    // convert SVG to png image (required for filters)
                                    // calc a multiplier that could fill the full preview
                                    let multiplier = Math.max( context.config.width / fabricSvg.viewBoxWidth, context.config.height / fabricSvg.viewBoxHeight);
                                    let dataUrl = fabricSvg.toDataURL({
                                        multiplier: Math.min(10, multiplier), // cap multiplier at 10 (to avoid very large images)
                                        format: 'png'
                                    });

                                    fabric.Image.fromURL(dataUrl, (fabricImg) => {
                                        // call prepare for same logic as if this image was uploaded
                                        prepareImage(fabricImg);
                                    });

                                }, null, { crossOrigin: 'anonymous'}); // crossOrigin required for canvas export support
                            }
                            // default load image form url
                            else {
                                fabric.Image.fromURL(url, prepareImage, { crossOrigin: 'anonymous'}); // crossOrigin required for canvas export support
                            }


                        });
                    }
                }
                // NEW: image placeholder support (useful to open upload picker via click on preview)
                else if(layer.params.urlPlaceholder) {
                    return new Promise((resolve, reject) => {
                        // INFO: no modifications are applied (e.g filters, rotate) to placeholder image ONLY images or SVG with width/height attributes are supported
                        fabric.Image.fromURL(layer.params.urlPlaceholder, (fabricImg) => {

                            // image filters
                            resolve(fabricImg);
                        }, {crossOrigin: 'anonymous'}); // crossOrigin required for canvas export support);
                    });
                }

            } else {
                log.warn('no upload option found for layer', layer);
            }

        } else {
            log.warn('missing option for layer', layer);
        }


        return Promise.resolve(null);
    }

    _applyFilters(object, layer, context){

        let filterPromise = Promise.resolve(null);

        if(layer.params.filters && layer.params.filters.length){

            // copy of filters to be applied
            let filters = [... layer.params.filters ];

            // increase size (default 2000) required for larger images filters: https://stackoverflow.com/a/55608839
            if(object.width > fabric.textureSize || object.height > fabric.textureSize){
                // increase to fit image
                let minTexture = Math.max(object.height, object.width);
                // NEW: texture size could only be updated once - we set it to at least 4069
                if(minTexture > 4096){
                    fabric.textureSize = minTexture;
                } else {
                    // default double size
                    fabric.textureSize = 4096;
                }
            }

            // NEW: filter with external image && image is not already cached
            if(layer.params.urlFilter && !(layer._urlFilterImage && layer._urlFilter === layer.params.urlFilter)){

                filterPromise = filterPromise.then(() => new Promise((resolve, reject) => {

                    fabric.Image.fromURL(layer.params.urlFilter, (fabricImg) => {

                        if(fabricImg){
                            // cache object & url
                            layer._urlFilter = layer.params.urlFilter;
                            layer._urlFilterImage = fabricImg;
                        }

                        resolve();
                    }, { crossOrigin: 'anonymous'});
                }));

            }

            // NEW: pattern filter - we create a pattern of the provided mask to match the object dimensions
            // INFO: we have to recreate the pattern when upload url changes (only then this function is called)
            if(layer.params.urlFilter && filters.indexOf('pattern') !== -1){

                filterPromise = filterPromise.then(() => new Promise((resolve, reject) => {

                    let filterImgEl = layer._urlFilterImage.getElement();

                    // create a shape with the same dimensions as the object
                    let scaledWidth = object.getScaledWidth();
                    let scaledHeight = object.getScaledHeight();

                    let shape = new fabric.Rect({
                        width: scaledWidth,
                        height: scaledHeight,
                    });

                    // add filter to shape with pattern to repeat
                    shape.set('fill', new fabric.Pattern({
                        source: filterImgEl,
                        repeat: 'repeat'
                    }));

                    // generate a new image from shape with the pattern
                    let dataURL = shape.toDataURL();

                    fabric.Image.fromURL(dataURL, (fabricImg) => {

                        if(fabricImg){
                            // cache object & url
                            // layer._urlFilterMask = layer.params.urlFilter; (we have to recreate the mask when upload url changes)
                            layer._urlFilterImagePattern = fabricImg;
                        }

                        resolve();
                    });

                }));

                // IMPORTANT: hacky removeWhite needs to be applied to the base image (the pattern switches the object to the pattern which then does not apply the removeWhite to the right image)
                if(filters.indexOf('removeWhite') !== -1){

                    filterPromise = filterPromise.then(() => new Promise((resolve, reject) => {

                        object.applyFilters([new fabric.Image.filters.RemoveColor({
                            threshold: 0.2,
                        })]);

                        fabric.Image.fromURL(object.toDataURL(), (fabricImg) => {

                            if(fabricImg){
                                // store image to be used as image for pattern
                                layer._urlFilterImageBlend = fabricImg;

                                // IMPORTANT: skip removeWhite from filters to avoid applying to the pattern
                                layer._removeWhiteSkip = true;
                            }

                            resolve();
                        });

                    }));

                }

            }

            // NEW: removeBg filter (we are not using fabricJS filters - only API call and replace the underlying image)
            if(filters.indexOf('removeBg') !== -1 && layer.params.removeBgKey){

                let src = object.getSrc(false);

                // get file extension from src
                let ext = src.substring(src.lastIndexOf('.')).toLowerCase();

                // NEW: only apply to supported images
                if(ext === '.jpg' || ext === '.jpeg' || ext === '.png' ) {

                    filterPromise = filterPromise.then(() => new Promise((resolve, reject) => {

                        let request = new Request('https://api.remove.bg/v1.0/removebg', {
                            method: 'POST',
                            responseType: 'blob', // create blob from response
                            headers: {
                                'X-API-Key': layer.params.removeBgKey,
                                'Content-type': 'application/x-www-form-urlencoded' // IMPORTANT: required to serialize params correctly
                            },
                            data: {
                                'image_url': src,
                                'size': layer.params.removeBgSize || window.clRemoveBgSize || 'auto', // support preview only size
                                'type': 'auto'
                            }
                        });

                        request.then((response) => {
                            // we create a new image object to replace the underlying image (to keep the fabricImage reference the same)

                            // INFO: this breaks EXPORT extension - we would need to upload this image first and then replace the url (wait before this is actually requested)
                            const objectURL = URL.createObjectURL(response.data);
                            let imageNoBg = new Image();

                            imageNoBg.onload = () => {
                                object.setElement(imageNoBg);
                                // set flag to always export as png
                                layer._removeBg = true;
                                resolve();
                            };

                            // INFO: no cache needed - the fabricObj is already cached based on the upload url
                            imageNoBg.src = objectURL;

                        }).catch((error) => {
                            // log error but continue
                            log.error(error);
                            resolve();
                        });

                    }));
                }
            }


            filterPromise.then(() => {

                if(!object.filters){
                    object.filters = [];
                }

                for (let i = 0; i < filters.length; i++) {
                    const filterType = filters[i];

                    let filter;

                    // manual mapping for custom filter support
                    switch(filterType){
                        case 'pattern':
                            if(layer._urlFilterImagePattern){

                                // blend with 'mask' requires to actually flip the object image to the filter and then apply the image as a mask to achieve a "pattern" effect
                                let image = layer._urlFilterImageBlend; // removeWhite case already has the image prepared

                                // default create new image from object
                                if(!image){
                                    image = new fabric.Image();
                                    image.setElement(object.getElement());
                                }

                                // set pattern as base image of the object
                                object.setElement(layer._urlFilterImagePattern.getElement());

                                filter = new fabric.Image.filters.BlendImage({
                                    image: image,
                                    mode: 'mask'
                                });

                                filter._sort = 7;
                            }
                            break;
                        case 'multiply':
                            if(layer._urlFilterImage){
                                filter = new fabric.Image.filters.BlendImage({
                                    image: layer._urlFilterImage,
                                    mode: 'multiply',
                                    alpha: layer.params.alphaFilter || 0.5 // INFO: alpha is not implemented in the filter..
                                });
                                filter._sort = 6;
                            }
                            break;
                        case 'invert':
                            filter = new fabric.Image.filters.Invert();
                            filter._sort = 2;
                            break;
                        case 'grayscale':
                            filter = new fabric.Image.filters.Grayscale();
                            filter._sort = 6;
                            break;
                        case 'sepia':
                            filter = new fabric.Image.filters.Sepia();
                            filter._sort = 5;
                            break;
                        case 'removeWhite':

                            // set in combination with pattern - removeWhite already applied above
                            if(layer._removeWhiteSkip){
                                break;
                            }

                            filter = new fabric.Image.filters.RemoveColor({
                                threshold: 0.2,
                            });
                            filter._sort = 1; // always execute first
                            break;
                    }

                    if(filter){
                        object.filters.push(filter);
                        // potentially custom filter settings ( no update support as filters are cached )
                    }
                }

                if(object.filters.length){
                    // filter apply order does impact outcome
                    // sort by _sort (default 100 = last)
                    object.filters.sort((a, b) => ((a._sort || 100) > (b._sort || 100)) ? 1 : -1)
                }

                // applied filters for cache check
                layer._filters = [... filters ];

                object.applyFilters();
            });
        }

        // Feature flag - disabled by default
        if (ThemeConfig.previewImgResize) {
            return filterPromise.then(() => {
                this._applyResizeFilter(object, layer, context);
            });
        }

        return filterPromise;
    }

    /**
     * Apply resize filter for better image quality when downscaling large images.
     * Uses Fabric.js built-in Resize filter with hermite algorithm for canvas2d.
     *
     * @param {fabric.Image} fabricImg - The fabric image object
     * @param {Object} layer - The layer configuration
     * @param {Object} context - The render context
     */
    _applyResizeFilter(fabricImg, layer, context) {
        // Only apply to actual images (not SVG groups)
        if (!fabricImg || fabricImg.type !== 'image') {
            return;
        }

        // Check if Resize filter is available
        if (typeof fabric.Image.filters.Resize === 'undefined') {
            log.debug('Resize filter not available in this Fabric.js version');
            return;
        }

        // Get reference dimensions to calculate expected scale
        let refDimensions = RenderUtil.getRefDimensions(layer, context);

        // Calculate the scale factor that will be applied
        let scaleX = refDimensions.width / fabricImg.width;
        let scaleY = refDimensions.height / fabricImg.height;

        // Use the smaller scale (same logic as autoScale with autoScaleRatio)
        let expectedScale = Math.min(scaleX, scaleY);

        // For autoScaleOverlay, use the larger scale
        if (layer.params.autoScaleOverlay) {
            expectedScale = Math.max(scaleX, scaleY);
        }

        // Only apply resize filter if significant downscaling will occur (below 50%)
        // This threshold avoids unnecessary filter overhead for small scale changes
        let resizeThreshold = window.clResizeThreshold || 0.5;

        if (expectedScale < resizeThreshold) {
            // Use hermite for canvas2d - good balance of quality and performance
            // Options: 'bilinear', 'hermite', 'sliceHack', 'lanczos'
            // lanczos is highest quality but slowest, hermite is a good middle ground
            let resizeType = window.clResizeType || 'hermite';

            fabricImg.resizeFilter = new fabric.Image.filters.Resize({
                resizeType: resizeType
            });

            // Set minimumScaleTrigger to activate filter at our threshold
            // This ensures the filter is applied when the image is rendered at the calculated scale
            fabricImg.minimumScaleTrigger = resizeThreshold;

            log.debug('Applied resize filter:', resizeType, 'for scale:', expectedScale.toFixed(2));
        }
    }

}

export default UploadRenderer;
